import type { ImageProps } from '~/components/UI/Image'
import type { Media } from '~/data/serialize-media'
import { getIsProductFashion, getIsProductSet } from '~/utils/get-shopify-product-type'

type TCaseType = 'IS_PRODUCT_SET_OR_FASHION' | 'NO_VARIANT_WITH_VIDEO' | 'NO_VARIANT_WITHOUT_VIDEO' | 'DEFAULT'

function getCurrentImagePDP(type: string, medias: Media[], images: ImageProps[], variantIndex: number, hasQueryVariant: boolean) {
  const isProductSetOrFashion =
    getIsProductSet(type) || getIsProductFashion(type)
  const firstMedia = medias?.[0] ?? null
  const hasImage = images?.[variantIndex] ?? images?.[0] ?? null
  const hasVideo = firstMedia?.video ?? null

  if (isProductSetOrFashion || (!hasQueryVariant && hasVideo) || (!hasQueryVariant && !hasVideo)) {
    return firstMedia
  }
  return {
    image: hasImage,
    video: null,
  }

}

export default getCurrentImagePDP;